import gql from 'graphql-tag';

export default fields => gql`
query ($filter: TableAdvertiserFilterInput, $limit: Int, $nextToken: String) {
  listAdvertisers (filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
    nextToken
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Advertisers/AllQuery.js